/**
 * Fisher–Yates shuffle, returning a new array (does not mutate the input).
 *
 * Used to decorrelate independent media players: every RegionPlayer / GoonFuel
 * fetches the same ordered feed, so without a per-instance shuffle they would all
 * start on the same clip and advance in lockstep — showing the same video at the
 * same time. Shuffling each fetched page per instance makes their streams diverge.
 */
export function shuffle<T>(input: readonly T[]): T[] {
  const out = input.slice();
  for (let i = out.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [out[i], out[j]] = [out[j], out[i]];
  }
  return out;
}
